export const getBoundDate = <T extends Date | string>(
    date?: T,
    min?: T,
    max?: T,
): T | undefined => {
    if (!date) {
        return undefined;
    }

    if (min && max && min > max) {
        return undefined;
    }

    if (min && date < min) {
        return min;
    }

    if (max && date > max) {
        return max;
    }

    return date;
};
